import { Pipe, PipeTransform } from '@angular/core';

import {
  isStandardBaseDefinitionRequired,
  SchemaStandardBaseDefinition
} from '@shared/models/schema-property-definition';

/**
 * Usages:
 * [isRequired]="schema.nonRecurringExpenses | standardRequirement"
 */
@Pipe({
  name: 'standardRequirement'
})
export class StandardRequirementPipe implements PipeTransform {
  transform<T>(property: SchemaStandardBaseDefinition): boolean {
    return isStandardBaseDefinitionRequired(property);
  }
}
